import { IPaginateList } from "../../interfaces/pagination";
import { supplier } from "../../redux/actions/actionContants";

export interface ISupplierState {
	result: any[];
	ingredients: IPaginateList<any[]> & { cache: { [page: number]: any[] } };
	isLoaded: boolean;
	currentSupplierId: string | null;
}

const INIT_STATE: ISupplierState = {
	result: [],
	ingredients: {
		list: [],
		pagination: {
			page: 1,
			pages: 0,
			size: 20,
			total: 0
		},
		cache: {}
	},
	isLoaded: false,
	currentSupplierId: null
};

export default function (state: ISupplierState = INIT_STATE, action: any) {
	switch (action.type) {
		case supplier.GET_SUPPLIER_INGREDIENT:
			const isNewSupplier = state.currentSupplierId !== action.payload.supplierId;
			return {
				...state,
				currentSupplierId: action.payload.supplierId,
				ingredients: {
					...action.payload,
					cache: {
						...(isNewSupplier ? {} : state.ingredients.cache),
						[action.payload.pagination.page]: action.payload.list
					}
				}
			};
		case supplier.PAGINATE_SUPPLIER_INGREDIENT:
			return {
				...state,
				ingredients: {
					...state.ingredients,
					pagination: {
						...state.ingredients.pagination,
						page: action.payload
					}
				}
			};
		case supplier.GET_ALL_SUPPLIER_RESPONSE:
			return {
				...state,
				result: action.payload,
				isLoaded: true
			};

		default:
			return state;
	}
}
